import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

type UseDeleteAreaTypeMutationProps = {
	closeDeleteModal: () => void
}

export const useDeleteAreaTypeMutation = ({ closeDeleteModal }: UseDeleteAreaTypeMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const deleteAreaTypeMutation = useMutation({
		mutationFn: (id: number) => {
			return axiosPrivate.delete(apiRoutes.areaType(id.toString()))
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.boothTypes.all })
			useToast({
				type: 'success',
				message: t('Area type deleted')
			})()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		},
		onSettled: () => {
			closeDeleteModal()
		}
	})

	return {
		deleteAreaTypeMutation
	}
}
